
import $ from "jquery"
import Modal from "app/modal/show-modal"
import Map_Session from "app/map/session"

import {
  Filter as AppSearchFilter,
} from "app/search/filter"

import {
  Factory as SaveSearchContainerFactory,
} from "apps/spacious_website/pages/shared/mobile_ver/components/save_search/index"

const show = () => {
  // # Blocks execution of this file whenever it"s in map view and
  // # the last listing modal is gonna be shown.
  // #
  // TODO: this should be page level init
  if ($(".page-cities-search #map-canvas").length !== 0 &&
        Map_Session.getLastListingModalId() != null) {
    return
  }

  // # We just show it if it exists
  // # The actual logic is in controller mixin
  if ($("#modal-last-save-search-notice").length === 0) { return }

  const $modal = Modal.showModalWithSelector("#modal-last-save-search-notice", {customContent: true})
  if ($modal == null) { return }

  $modal.on( "click", (e) => {
    const $target = $(e.target)
    if (!$target.is(".btn-reset")) { return }

    const $clear_place_search = $target.data("clear_place_search")

    const resetMap = () => {
      // TODO: Refactor those file
      // valid here as function are executed after all file load
      import(
        "pages/cities/search/city-map"
      )
      .then(({CityMap}) => {
        return import(
          "concepts/listings/searches/filter_bar/index"
        )
        .then(({Factory: ListingFilter}) => {
          ListingFilter.instance().resetFilterCriteriaWithPlaces()
          CityMap.clearPlacesAutoCompleteMarkerGroup()
          AppSearchFilter.update()
          SaveSearchContainerFactory.instance().dismiss()
        })
      })
    }

    const resetPlacesOnly = () => {
      // TODO: Refactor those file
      import(
        "pages/cities/search/city-map"
      )
      .then(({CityMap}) => {
        return import(
          "concepts/listings/searches/filter_bar/index"
        )
        .then(({Factory: ListingFilter}) => {
          ListingFilter.instance().clearPlaces()
          CityMap.clearPlacesAutoCompleteMarkerGroup()
          AppSearchFilter.update()
        })
      })
    }
    // original timeout here
    if ($clear_place_search) {
      resetPlacesOnly()
    }
    else {
      resetMap()
    }
  })
}

export default {show}
